import Cookies from "js-cookie"
import { getApi, postApi } from "../APIManager/ApiManager"

const admin=localStorage.getItem('shopify')
const user=localStorage.getItem('qwerty')
const uuid=btoa(Cookies.get('session') || localStorage.getItem('session'))

export const getStoreList=(id)=>{
    return getApi('/api/v2/offer/findoffer/'+id)
}